import api from './client'
import type { CreateUserRequest, PaginatedResponse, UpdateUserRequest, User, UserFilters } from '../api'

export const userAdminApi = {
  list: async (filters: UserFilters = {}): Promise<PaginatedResponse<User>> => {
    const response = await api.get<PaginatedResponse<User>>('/users', { params: filters })
    return response.data
  },

  get: async (id: string): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`)
    return response.data
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await api.post<User>('/users', data)
    return response.data
  },

  update: async (id: string, data: UpdateUserRequest): Promise<User> => {
    const response = await api.patch<User>(`/users/${id}`, data)
    return response.data
  },

  resendInvite: async (id: string): Promise<{ message: string; invite_expires_at: string | null }> => {
    const response = await api.post<{ message: string; invite_expires_at: string | null }>(`/users/${id}/resend-invite`)
    return response.data
  },

  resetTwoFactor: async (id: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>(`/users/${id}/reset-2fa`)
    return response.data
  },

  sendPasswordReset: async (id: string): Promise<{ message: string; expires_at: string | null }> => {
    const response = await api.post<{ message: string; expires_at: string | null }>(`/users/${id}/password-reset`)
    return response.data
  },
}
